"use strict";
/**
 * API helper for StudentProgram CRM sync endpoints.
 *
 * After a student degree plan is saved or deleted the front-end must push
 * off-sequence / final-term-active values to Salesforce via the backend
 * esil-crm integration.  The legacy Angular app does this with a second
 * PUT to /studentProgram/crm/update — this module provides the same call.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.studentProgramApi = void 0;
const apiClient_1 = require("./apiClient");
exports.studentProgramApi = {
    /**
     * Push off-sequence and final-term-active data to Salesforce via esil-crm.
     */
    updateStudentProgramCrm: (payload) => apiClient_1.apiClient.put('/studentProgram/crm/update', payload).then(() => { }),
};
